<template>
  <div class="article-content">
    <AbstractText :article="article" :citation-style="citationStyle" />
    <ArticleKeywordTags
      v-if="article.keywords.length > 0 && newArticleDetailsDisplay"
      :article="article"
    />
    <MaterialsDownload
      :article="article"
      :autoplay="autoplay"
      :video-usage="videoUsage"
      data-test-id="DownloadWithinContentHeadingButton"
    />
  </div>
</template>

<script>
import ArticleKeywordTags from "~/components/articles/components/ArticleKeywordTags.vue";
import AbstractText from "~/components/articles/components/AbstractText.vue";
import MaterialsDownload from "~/components/articles/components/MaterialsDownload.vue";
import mapFlags from "~/plugins/utilities/mapFlags";

export default {
  name: "ArticleContent",
  components: {
    AbstractText,
    MaterialsDownload,
    ArticleKeywordTags,
  },
  props: {
    article: { type: Object, required: true },
    citationStyle: { type: Object, default: undefined },
    autoplay: { type: Boolean, default: false },
    videoUsage: { type: Boolean, default: false },
  },
  computed: {
    ...mapFlags(["newArticleDetailsDisplay"]),
  },
};
</script>
